//用户接口相关的函数
import request from "@/untils/request.js"

/**
 *
 * @param { post } data
 *  
 */

// 存入数据库 => 古
export const addInfYB = (data) => {
    return request.post("/outpatient/addInf", data)
}



/**
 *
 * @param { get } params
 *  
 */

// 老游接口收钱吧支付获取结算id
export const getlyId = (params) => {
    return request.get("/outpatient/sqb/query", { params } )
}

// 库存维护接口
export const getChs = (params) => {
    return request.get("/outpatient/getChs", { params } )
}

/**
 *
 * @param { DELETE } params
 *  
 */  

// 删除
export const deletePlanData = (params) => {
    return request.delete("/outpatient/deletePlanData", { params })
}


// 暴露
export default{
	// post
	addInfYB,
    // get
	getlyId,getChs,
	
}